export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const passwordPattern =
  /^(?=^.{8,20}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
export const numberPattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/ || /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const sizeLimit = 1024 * 1024;
export const  nospecial:any=/^[a-zA-Z_0-9@\!#\$\^%&*()+=\-[]\\\';,\.\/\{\}\|\":<>\? ]+$/;
export const KadooPattern:any =/[ `!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?~]/;;
export const numLim:any = /\b(0?[1-9]|[1-3][0-9]|40)\b/
export const SpecialPatt:any =  /[^a-z0-9 .]/gi;



// export const CountPattern = /^[1-9]$|^0[1-9]$|^1[0-9]$|^20$/


